import React from "react";
import {
  PhoneIcon,
  BellAlertIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";
import { AdmissionForm } from "./AdmissionForm";

export const UserActions = () => {
  return (
    <div className="flex flex-wrap justify-end items-center gap-4 pr-4 mt-4">
      {/* Email Icon */}
      <div className="flex items-center">
        <button className="flex items-center space-x-2">
          <PhoneIcon className="size-6 text-[#556d89]" />
          <span className="text-sm text-[#556d89]">Contact us</span>
        </button>
      </div>
      <div className="flex items-center">
        <AdmissionForm />
      </div>
      {/* Instagram Icon 
      <div className="flex items-center">
        <button className="relative flex-col flex items-center group">
          <img src="instagram.png" className="size-8" alt="Instagram" />

          <div className="absolute top-full mt-2 hidden text-sm text-gray-600 whitespace-nowrap group-hover:block transform -translate-x-1/2 left-1/2">
            Instagram
          </div>
        </button>
      </div>

      {/* WhatsApp Icon 
      <div className="flex items-center">
        <button className="relative flex-col flex items-center group">
          <img src="whatsapp.png" className="size-8" alt="WhatsApp" />

          <div className="absolute top-full mt-2 hidden text-sm text-gray-600 whitespace-nowrap group-hover:block transform -translate-x-1/2 left-1/2">
            WhatsApp
          </div>
        </button>
      </div>

      {/* Facebook Icon 
      <div className="flex items-center">
        <button className="relative flex-col flex items-center group">
          <img src="facebook.png" className="size-8" alt="Facebook" />

          <div className="absolute top-full mt-2 hidden text-sm text-gray-600 whitespace-nowrap group-hover:block transform -translate-x-1/2 left-1/2">
            Facebook
          </div>
        </button>
      </div>
      */}
      {/* Notification Icon 
      <div className="flex items-center">
        <button className="relative flex-col flex items-center group">
          <BellAlertIcon className="size-8 text-[#556d89]" />

          <div className="absolute top-full mt-2 hidden text-sm text-[#556d89] whitespace-nowrap group-hover:block transform -translate-x-1/2 left-1/2">
            Notification
          </div>
        </button>
      </div>*/}
    </div>
  );
};
